import { Table, TableColumnsType } from "antd";
import moment from "moment";
import QueryString from "qs";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { getEvents } from "../../../api/events.api";
import Button from "../../../components/Button";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import Pagination from "../../../components/Pagination";
import useAuth from "../../../hooks/useAuth";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import { IEventItem, IGetEvents } from "../../../models/events.model";

const Session = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { data: res, isLoading, error, execute } = useAxios<IGetEvents>();

  const [eventName, setEventName] = useState('');
  const [page, setPage] = useState<number>(1);
  const [param, setParam] = useState({});

  useEffect(() => {
    const _param: any = {
      pageNo: page,
      perPage: config.pageSize
    };

    if (query.page) {
      const _page = Number(query.page);
      setPage(_page);
      _param.page = _page;
    }
    if (query.eventName) {
      const _eventName = String(query.eventName);
      setEventName(_eventName);
      _param.eventName = _eventName;
    }

    execute(getEvents('FR', _param));
    _param.page = _param.pageNo;
    delete _param.pageNo;
    delete _param.perPage;
    setParam(_param);
  }, [location]);

  const onSearch = () => {
    const param: any = { page: 1 };
    if (eventName) param.eventName = eventName;
    history.push(`/business/session?${QueryString.stringify(param)}`);
  }

  const columns: TableColumnsType<IEventItem> = [
    {
      title: t('business.session.column1'),
      dataIndex: 'eventNo',
      key: 'eventNo',
      align: 'center',
      sorter: (a, b) => a.eventNo - b.eventNo,
    },
    {
      title: t('business.session.column2'),
      dataIndex: 'eventName',
      key: 'eventName',
      sorter: (a, b) => a.eventName?.localeCompare(b.eventName),
    },
    {
      title: t('business.session.column3'),
      dataIndex: 'openYn',
      key: 'openYn',
      align: 'center',
      sorter: (a, b) => a.openYn?.localeCompare(b.openYn),
    },
    {
      title: t('business.session.column4'),
      dataIndex: 'quota',
      key: 'quota',
      align: 'center',
      sorter: (a, b) => a.quota - b.quota,
      render: value => value === 0 ? t('business.session.column8') : `${t('business.session.column9')}${value?.toLocaleString()}${t('business.session.column10')}`,
    },
    {
      title: t('business.session.column5'),
      dataIndex: 'eventDate',
      key: 'eventDate',
      align: 'center',
      sorter: (a, b) => a.eventDate?.localeCompare(b.eventDate),
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('business.session.column6'),
      dataIndex: 'registSrtDate',
      key: 'registSrtDate',
      align: 'center',
      sorter: (a, b) => a.registSrtDate?.localeCompare(b.registSrtDate),
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('business.session.column7'),
      dataIndex: 'registEndDate',
      key: 'registEndDate',
      align: 'center',
      sorter: (a, b) => a.registEndDate?.localeCompare(b.registEndDate),
      render: value => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
    <SimpleHeader
      iconFile="icon-business-big.svg"
      parentMenu={t('common.menu.business')}
      currentMenu={t('business.session.title1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('business.session.column2')}</label>
            <input
              type="text"
              className="form-control w-240p"
              placeholder={t('business.session.placeholder1')}
              value={eventName}
              onChange={e => setEventName(e.target.value)}
              onKeyPress={e => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result">
            {t('common.text.count')}: <b>{res?.total}</b>{t('common.text.unit')}
          </div>
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/business/session/create')}
              text={t('common.button.create')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{
              current: page,
              pageSize: config.pageSize
            }}
            onRow={record => {
              return {
                onClick: () => {
                  history.push(`/business/session/${record.eventNo}${location.search}`);
                }
              };
            }}
            rowClassName="pointer"
            rowKey="eventNo"
          />
        </div>
        <div className="comm-bx__between">
          <div />
          <div className="common-paging center">
            <Pagination
              count={res?.total || 0}
              page={page}
              param={param}
              path="/business/session"
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/business/session/create')}
              text={t('common.button.create')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>

      </div>
    </div>
    </>
  );
}

export default Session;
